"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateStudyQueryUploadApplyStatusResponse = exports.GetStudyQueryDownloadUrlResponse = exports.StudyQueryExportFormat = void 0;
var StudyQueryExportFormat;
(function (StudyQueryExportFormat) {
    StudyQueryExportFormat["Excel"] = "XLS";
    StudyQueryExportFormat["CSV"] = "CSV";
})(StudyQueryExportFormat = exports.StudyQueryExportFormat || (exports.StudyQueryExportFormat = {}));
class GetStudyQueryDownloadUrlResponse {
}
exports.GetStudyQueryDownloadUrlResponse = GetStudyQueryDownloadUrlResponse;
class UpdateStudyQueryUploadApplyStatusResponse {
}
exports.UpdateStudyQueryUploadApplyStatusResponse = UpdateStudyQueryUploadApplyStatusResponse;
//# sourceMappingURL=studyQuery.js.map